/** @format */

export const TEST_ID = 'price-filter';

export enum CustomRangeField {
    FROM = 'from',
    TO = 'to',
}

export const MAX_CUSTOM_RANGE = 999_999_999;
